import { InfoItemHorizontal } from "components";
import { useFormikContext } from "formik";
import React from "react";
import { DateConvert } from "utilities";

export const InfoSection = () => {
  const { values } = useFormikContext();

  return (
    <>
      <InfoItemHorizontal
        label="Tgl. Stock Fisik"
        text={
          values?.tglStockFisik &&
          DateConvert(new Date(values?.tglStockFisik)).detail
        }
      />
      <InfoItemHorizontal
        label="No. Stock Fisik"
        text={values?.noStockFisik ?? "-"}
      />
      <InfoItemHorizontal
        label="Unit Produksi"
        text={values?.namaUnitProduksi ?? "-"}
      />
      <InfoItemHorizontal label="Gudang" text={values?.namaGudang ?? "-"} />
    </>
  );
};
